import { metricOperations } from '../../utils/percentageMetrics'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import HMapLabel from '../../components/HMapLabel'
import HMapTextField from '../../components/HMapTextField'
import HMapTextArea from '../../components/HMapTextArea'
import HMapBubbleSlider from '../../components/HMapBubbleSlider'
import HMapShadowSlider from '../../components/HMapShadowSlider'
import HMapColorSlider from '../../components/HMapColorSlider'
import HMapColorPicker from '../../components/HMapColorPicker'
import HMapAutoComplete from '../../components/HMapAutoComplete'
import { WSpacer } from '../../components/HMapSpacer'

const HMapDetailsContent = ({ operations, dynamicFields, onChange, formFields }) => {
  const classes = useStyles()

  const operationsOptions = operations.map((field, idx) => ({
    value: field.value,
    text: field.text,
    index: idx
  }))

  const dynamicFieldsOptions = dynamicFields.map((field, idx) => ({
    value: field.id,
    text: field.label,
    index: idx
  }))

  return (
    <div className={classes.root}>
      {dynamicFields.some(field => field.config?.format === 'percentage' && ['number', 'size', 'color', 'shadow'].some(ref => formFields?.[ref + 'Field'] === field.id)) && (
        <p>Percentage fields use a fixed 0–100% scale: 60% always maps to the 60% range. Pin Value selects the cluster calculation: Average, Minimum or Maximum. Older Sum or Count settings display Average until updated.</p>
      )}
      <div className={`${classes.panelRow} ${classes.borderBottom}`}>
        <HMapLabel width={'35%'} text="Heatmap Name" fontType="h3" />
        <HMapTextField
          width={'65%'}
          type="text"
          name="name"
          className={classes.inputField}
          placeholder=""
          onChange={onChange}
          value={undefined}
        />
      </div>
      <div className={`${classes.panelRow} ${classes.borderBottom}`}>
        <HMapLabel width={'35%'} text="Heatmap Description" fontType="h3" />
        <HMapTextArea
          width={'65%'}
          type="text"
          name="description"
          className={classes.inputField}
          placeholder=""
          onChange={onChange}
          value={undefined}
        />
      </div>
      <div className={`${classes.panelRow} ${classes.borderBottom}`}>
        <HMapLabel width={'20%'} text="Pin Style" fontType="h3" />
        <HMapLabel width={'50%'} text="1.Select Pin Data" fontType="h3" />
        <HMapLabel width={'30%'} text="2.Pin Value" fontType="h3" />
      </div>
      {/* Number */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Number" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            // selectedOption={fields.numberField}
            // setSelectedOption={setFieldValue}
            name={'numberField'}
            options={dynamicFieldsOptions}
            onChange={onChange}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            // selectedOption={fields.numberClac}
            // setSelectedOption={setFieldValue}
            selectedOption={operationsOptions.find(option => option.value === formFields?.numberCalc)}
            key={'numberCalc-' + formFields?.numberField}
            name={'numberCalc'}
            options={metricOperations(operationsOptions, dynamicFields, formFields?.numberField)}
            onChange={onChange}
          />
        </div>
      </div>
      {/* Size */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Size" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            // selectedOption={fields.sizeField}
            // setSelectedOption={setFieldValue}
            name={'sizeField'}
            options={dynamicFieldsOptions}
            onChange={onChange}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            // selectedOption={fields.sizeClac}
            // setSelectedOption={setFieldValue}
            selectedOption={operationsOptions.find(option => option.value === formFields?.sizeCalc)}
            key={'sizeCalc-' + formFields?.sizeField}
            name={'sizeCalc'}
            options={metricOperations(operationsOptions, dynamicFields, formFields?.sizeField)}
            onChange={onChange}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapBubbleSlider
            width={'80%'}
            name={'sizeSlider'}
            onChange={onChange}
          />
        </div>
      </div>
      {/* Color */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Color" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            // selectedOption={fields.colorField}
            // setSelectedOption={setFieldValue}
            name={'colorField'}
            options={dynamicFieldsOptions}
            onChange={onChange}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            // selectedOption={fields.colorClac}
            // setSelectedOption={setFieldValue}
            selectedOption={operationsOptions.find(option => option.value === formFields?.colorCalc)}
            key={'colorCalc-' + formFields?.colorField}
            name={'colorCalc'}
            options={metricOperations(operationsOptions, dynamicFields, formFields?.colorField)}
            onChange={onChange}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapColorPicker
            name="colorHexes"
            colors={formFields?.colorHexes}
            onChange={onChange}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapColorSlider
            width={'80%'}
            name={'colorSlider'}
            colors={formFields?.colorHexes}
            onChange={onChange}
          />
        </div>
      </div>
      {/* Shadow */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Shadow" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            // selectedOption={fields.shadowField}
            // setSelectedOption={setFieldValue}
            name={'shadowField'}
            options={dynamicFieldsOptions}
            onChange={onChange}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            // selectedOption={fields.shadowClac}
            // setSelectedOption={setFieldValue}
            selectedOption={operationsOptions.find(option => option.value === formFields?.shadowCalc)}
            key={'shadowCalc-' + formFields?.shadowField}
            name={'shadowCalc'}
            options={metricOperations(operationsOptions, dynamicFields, formFields?.shadowField)}
            onChange={onChange}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapShadowSlider
            width={'80%'}
            name={'shadowSlider'}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  )
}

export default React.memo(HMapDetailsContent)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '0px 10px',
    overflowX: 'hidden',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 5
    }
  },
  panelMultiRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  panelRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 5px'
  },
  borderBottom: {
    borderBottom: `1px solid ${theme.palette.secondary.main}`
  }
}))
